import { render, staticRenderFns } from "./bgColorSelect.vue?vue&type=template&id=56b3e31a&scoped=true&"
import script from "./bgColorSelect.vue?vue&type=script&lang=js&"
export * from "./bgColorSelect.vue?vue&type=script&lang=js&"
import style0 from "./bgColorSelect.vue?vue&type=style&index=0&id=56b3e31a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b3e31a",
  null
  
)

export default component.exports